const baseColors = {
  blue: '#0066FF',
  orange: '#FE5100',
  yellow: '#FFD000',
  gray: '#1B1B20',
  green: '#00C057',
  red: '#EE0007',
  purple: '#9146FF',
};

export const blue900: string = '#003288';
export const blue800: string = '#003FA4';
export const blue700: string = '#004BC2';
export const blue600: string = '#0059E1';
export const blue500: string = baseColors.blue;
export const blue400: string = '#328DFF';
export const blue300: string = '#68AFFF';
export const blue200: string = '#9DCEFF';
export const blue100: string = '#DAEDFF';
export const blue50: string = '#F4FAFF';

export const orange900: string = '#6C1D00';
export const orange800: string = '#842600';
export const orange700: string = '#9C2E00';
export const orange600: string = '#B43700';
export const orange500: string = '#D54300';
export const orange400: string = baseColors.orange;
export const orange300: string = '#FF8A77';
export const orange200: string = '#FFB8AF';
export const orange100: string = '#FFE5E3';
export const orange50: string = '#FFF8F7';

export const yellow900: string = '#4F3400';
export const yellow800: string = '#5E4200';
export const yellow700: string = '#6E5000';
export const yellow600: string = '#7D5F00';
export const yellow500: string = '#AE8900';
export const yellow400: string = '#D1AA00';
export const yellow300: string = baseColors.yellow;
export const yellow200: string = '#FDDA80';
export const yellow100: string = '#FCE8BF';
export const yellow50: string = '#FEF6E7';

export const gray950: string = '#131317';
export const gray900: string = baseColors.gray;
export const gray800: string = '#29292F';
export const gray700: string = '#3B3B43';
export const gray600: string = '#4E4E58';
export const gray500: string = '#62626D';
export const gray400: string = '#767680';
export const gray300: string = '#8D8D95';
export const gray200: string = '#ABABB1';
export const gray150: string = '#C9C9CD';
export const gray100: string = '#E2E2E4';
export const gray75: string = '#EEEEEF';
export const gray50: string = '#F6F6F7';
export const gray25: string = '#FCFCFC';

export const green900: string = '#00431A';
export const green800: string = '#005321';
export const green700: string = '#006329';
export const green600: string = '#007331';
export const green500: string = '#00893C';
export const green400: string = '#00A449';
export const green300: string = baseColors.green;
export const green200: string = '#7EDD92';
export const green100: string = '#D1F4D5';
export const green50: string = '#F3FCF4';

export const red900: string = '#790002';
export const red800: string = '#930002';
export const red700: string = '#AE0003';
export const red600: string = '#CA0005';
export const red500: string = baseColors.red;
export const red400: string = '#FF4C4D';
export const red300: string = '#FF8889';
export const red200: string = '#FFB7B7';
export const red100: string = '#FFE5E5';
export const red50: string = '#FFF8F8';

export const purple900: string = '#50009C';
export const purple800: string = '#6100BD';
export const purple700: string = '#7400DF';
export const purple600: string = '#8609FF';
export const purple500: string = baseColors.purple;
export const purple400: string = '#A372FF';
export const purple300: string = '#B99AFF';
export const purple200: string = '#D1C0FF';
export const purple100: string = '#EEE8FF';
export const purple50: string = '#FAF8FF';

export const white: string = '#FFFFFF';

const colors = {
  blue900,
  blue800,
  blue700,
  blue600,
  blue500,
  blue400,
  blue300,
  blue200,
  blue100,
  blue50,
  gray950,
  gray900,
  gray800,
  gray700,
  gray600,
  gray500,
  gray400,
  gray300,
  gray200,
  gray150,
  gray100,
  gray75,
  gray50,
  gray25,
  red900,
  red800,
  red700,
  red600,
  red500,
  red400,
  red300,
  red200,
  red100,
  red50,
  orange900,
  orange800,
  orange700,
  orange600,
  orange500,
  orange400,
  orange300,
  orange200,
  orange100,
  orange50,
  yellow900,
  yellow800,
  yellow700,
  yellow600,
  yellow500,
  yellow400,
  yellow300,
  yellow200,
  yellow100,
  yellow50,
  purple900,
  purple800,
  purple700,
  purple600,
  purple500,
  purple400,
  purple300,
  purple200,
  purple100,
  purple50,
  green900,
  green800,
  green700,
  green600,
  green500,
  green400,
  green300,
  green200,
  green100,
  green50,
  white,
};

export default colors;
